import styled from '@emotion/styled';
import {LinkPrimary} from '../../styles';

export const StyledLinkPrimary = styled(LinkPrimary)`
  width: fit-content;
`;

// DESKTOP
export const DesktopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xl};
  padding: ${({theme}) => theme.padding.desktop.lg};
`;

export const DesktopContent = styled.div`
  display: flex;
  gap: ${({theme}) => theme.gap.desktop.xl};
`;

export const Separator = styled.div`
  width: 1px;
  background-color: ${({theme}) => theme.color.neutral.grey_300};
`;

export const CardColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.md};
`;

export const DesktopCircleWrapper = styled.div`
  width: 203px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// MOBILE
export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xl};
  padding: ${({theme}) => theme.padding.desktop.md};
  border-radius: ${({theme}) => theme.border.radius.md};
`;

export const MobileContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.lg};
`;

export const MobileCircleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
